export default __webpack_public_path__ + "static/media/aprTypeChangeIconDark.30ac55ef.svg";